import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import setModalAction from 'actions/setModal';

import { modalSelector } from './selectors';

const useModal = () => {
  const selector = useCallback(
    (state) => ({
      modalData: modalSelector(state),
    }),
    [],
  );

  const dispatch = useDispatch();

  const data = useSelector(selector);

  const actions = useMemo(
    () =>
      bindActionCreators(
        {
          setModal: (payload) => setModalAction(payload),
        },
        dispatch,
      ),
    [dispatch],
  );

  return {
    ...data,
    ...actions,
  };
};

export default useModal;
